document.addEventListener('DOMContentLoaded', function() {
    const compareButtons = document.querySelectorAll('.compare-button');
    
    compareButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const productId = button.dataset.productId;
        let compareList = localStorage.getItem('compareList');
        
        if (compareList) {
          compareList = JSON.parse(compareList);
        } else {
          compareList = [];
        }
        
        if (!compareList.includes(productId)) {
          compareList.push(productId);
          localStorage.setItem('compareList', JSON.stringify(compareList));
        }
      });
    });
});

$("#popupContainer").hide();

// Check if popup has been shown before
if (!localStorage.getItem("popupShown")) {
  // Show the popup
  $("#popupContainer").show();
}

// Handle Enter button click
$("#enterBtn").on("click", function() {
  // Set localStorage item to remember popup display
  localStorage.setItem("popupShown", true);
  
  // Hide the popup
  $("#popupContainer").hide();
});

$("#leaveBtn").on("click", function() {
  // Redirect to Google.com
  window.location.href = "https://www.google.com";
});


// header menu on hover
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
});

// sticky Header

$(window).scroll(function(){
      if ($(this).scrollTop() > 170) {
          $('.header__inline-menu').addClass('fixed');
      } else {
          $('.header__inline-menu').removeClass('fixed');
      }
});


// tablet Menu

  
$(".tablet-menu span").click(function() {
  $(this).toggleClass("on");
  $(".list-menu--inline").toggle();
});

$(".mega-menu .mega-menu__content ul li").click(function(){    
  if($(this).hasClass('active')){        
      $(this).removeClass('active'); 
      $(this).find('ul.list-unstyled').slideUp(300);
    }else{
      $(".mega-menu .mega-menu__content>ul li").removeClass('active');
      $(".mega-menu .mega-menu__content ul.list-unstyled").slideUp(300);
      $(this).addClass('active');
      $(this).find('ul.list-unstyled').slideDown(300);
    }
});
 
// mobile menu

  function mobileTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}


$(document).ready(function(){
  $(".mega-menu[open] .mega-menu__content ul li").click(function(){
    $(".mega-menu__list li > ul").toggle();
  });
});


// sidebar toggle

$(".block-title").click(function(){
  $(".top-block").toggle();
});



 $(document).ready(function(){
   // home silder
    $("#slideshow-owl-slider").owlCarousel({
      autoplay: true,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      responsive: {
        0: {
          items: 1
        },
    
        600: {
          items: 1
        },
    
        1024: {
          items: 1
        },
    
        1366: {
          items: 1
        }
      }
    });
   //  collection sidebar
   
    $(document).on("click", '.sidebar-content ul li', function() {
    
      var $clickedLi = $(this);
      var $siblingsLi = $clickedLi.siblings();
    
      $siblingsLi.removeClass('nav-active');
      $siblingsLi.children("ul").hide();
      $siblingsLi.children(".opener").html("+");
      
      $clickedLi.toggleClass('nav-active');
      $clickedLi.children('ul').slideToggle();
      
     if ($clickedLi.hasClass('nav-active')) {
        $clickedLi.find(".opener").html("-");
     } else {
        $clickedLi.find(".opener").html("+");
     }
      
   });

   //hover cart
   $('#cart-icon-bubble').on('mouseenter', function() {
     $('.mini-cart-content').show();
   }).on('mouseleave', function() {
     $('.mini-cart-content').hide();
   });

   //Change Layouts
  function activeLayoutTypes() {
    $('.layout-button--grid').toggleClass('active-layout', $('.collection-item').hasClass('collection-item--grid'));
    $('.layout-button--list').toggleClass('active-layout', $('.collection-item').hasClass('collection-item--list'));
  }
  
  activeLayoutTypes();
  
  // Change layouts on click in collection page
  $(document).on("click",'.layout-button--list, .layout-button--grid',function() {
    var isListLayout = $(this).hasClass('layout-button--list');
    $('.collection-item').toggleClass('collection-item--grid', !isListLayout).toggleClass('collection-item--list', isListLayout);
    activeLayoutTypes();
  });
   
});
